// extracted by mini-css-extract-plugin
module.exports = {"root":"processing_root__Kl6IN","rotation-spinner":"processing_rotation-spinner__lW46T"};